import { useGetPublicDesilLatest } from '@tatatemplate/shared-lib'

export function useLatestDesil() {
  return useGetPublicDesilLatest({
    query: { queryKey: ['desil', 'latest'], staleTime: 5 * 60 * 1000, retry: 3 },
  })
}
